import { Components, Theme } from '@mui/material/styles';
import { clarityTokens } from '@verifime/design-tokens';
import tokens from '@verifime/design-tokens'; // Standard tokens for fallback
import { outfit } from '../../fonts/outfit';

export const font = outfit;

export const typographyTheme = {
  fontFamily: font.style.fontFamily,
  h1: {
    fontSize: clarityTokens.fontSize4xl,
    fontWeight: clarityTokens.fontWeightSemibold,
    letterSpacing: clarityTokens.letterSpacingReg,
    lineHeight: clarityTokens.lineHeightStandard,
  },
  h2: {
    fontSize: clarityTokens.fontSize3xl,
    fontWeight: clarityTokens.fontWeightSemibold,
    letterSpacing: clarityTokens.letterSpacingReg,
    lineHeight: clarityTokens.lineHeightStandard,
  },
  h3: {
    fontSize: clarityTokens.fontSize2xl,
    fontWeight: clarityTokens.fontWeightSemibold,
    letterSpacing: clarityTokens.letterSpacingReg,
    lineHeight: clarityTokens.lineHeightStandard,
  },
  h4: {
    fontSize: clarityTokens.fontSizeXl,
    fontWeight: clarityTokens.fontWeightSemibold,
    letterSpacing: clarityTokens.letterSpacingReg,
    lineHeight: clarityTokens.lineHeightStandard,
  },
  h5: {
    fontSize: clarityTokens.fontSizeL,
    fontWeight: clarityTokens.fontWeightSemibold,
    letterSpacing: clarityTokens.letterSpacingReg,
    lineHeight: clarityTokens.lineHeightStandard,
  },
  h6: {
    fontSize: clarityTokens.fontSizeBase,
    fontWeight: clarityTokens.fontWeightSemibold,
    letterSpacing: clarityTokens.letterSpacingReg,
    lineHeight: clarityTokens.lineHeightStandard,
  },
  body1: {
    fontSize: clarityTokens.fontSizeBase,
    fontWeight: clarityTokens.fontWeightRegular,
    letterSpacing: clarityTokens.letterSpacingReg,
    lineHeight: clarityTokens.lineHeightStandard,
  },
  body2: {
    fontSize: clarityTokens.fontSizeSm,
    fontWeight: clarityTokens.fontWeightRegular,
    letterSpacing: clarityTokens.letterSpacingReg,
    lineHeight: clarityTokens.lineHeightStandard,
  },
  subtitle1: {
    fontSize: clarityTokens.fontSizeSm,
    fontWeight: clarityTokens.fontWeightSemibold,
    letterSpacing: clarityTokens.letterSpacingReg,
    lineHeight: clarityTokens.lineHeightStandard,
  },
  subtitle2: {
    fontSize: clarityTokens.fontSizeXs,
    fontWeight: clarityTokens.fontWeightSemibold,
    letterSpacing: clarityTokens.letterSpacingReg,
    lineHeight: clarityTokens.lineHeightStandard,
  },
  overline: {
    fontSize: clarityTokens.fontSizeXs,
    fontWeight: clarityTokens.fontWeightRegular,
    letterSpacing: clarityTokens.letterSpacingReg,
    lineHeight: clarityTokens.lineHeightStandard,
  },
  caption: {
    fontSize: clarityTokens.fontSizeXs,
    fontWeight: clarityTokens.fontWeightRegular,
    letterSpacing: clarityTokens.letterSpacingReg,
    lineHeight: clarityTokens.lineHeightStandard,
  },
};

export const paletteGrey = {
  '50': clarityTokens.colorGrey050,
  '100': clarityTokens.colorGrey100,
  '200': clarityTokens.colorGrey200,
  '300': clarityTokens.colorGrey300,
  '400': clarityTokens.colorGrey400,
  '500': clarityTokens.colorGrey500,
  '600': clarityTokens.colorGrey600,
  '700': clarityTokens.colorGrey700,
  '800': clarityTokens.colorGrey800,
  '900': clarityTokens.colorGrey900,
  A100: clarityTokens.colorGreyA100,
  A200: clarityTokens.colorGreyA200,
  A400: clarityTokens.colorGreyA400,
  A700: clarityTokens.colorGreyA700,
};

export const semanticBorderRadius = {
  sm: clarityTokens.borderRadiusSm,
  lg: clarityTokens.borderRadiusLg,
  xl: clarityTokens.borderRadiusXl,
  round: clarityTokens.borderRadiusRound,
};

export const semanticFontWeight = {
  // Note: 'light' and 'bolder' are not available in Clarity tokens, falling back to standard tokens
  light: tokens.fontWeightLight,
  regular: clarityTokens.fontWeightRegular,
  semibold: clarityTokens.fontWeightSemibold,
  bold: clarityTokens.fontWeightBold,
  bolder: tokens.fontWeightBolder,
};

export const semanticFontSize = {
  xs: clarityTokens.fontSizeXs,
  sm: clarityTokens.fontSizeSm,
  base: clarityTokens.fontSizeBase,
  // Note: Clarity uses 'l' (1.25rem) instead of 'lg' (1.125rem), falling back to standard token
  lg: tokens.fontSizeLg,
  l: clarityTokens.fontSizeL,
  xl: clarityTokens.fontSizeXl,
  '2xl': clarityTokens.fontSize2xl,
  '3xl': clarityTokens.fontSize3xl,
  '4xl': clarityTokens.fontSize4xl,
  // Note: '5xl', '6xl', '7xl', '8xl' are not available in Clarity tokens, falling back to standard tokens
  '5xl': tokens.fontSize5xl,
  '6xl': tokens.fontSize6xl,
  '7xl': tokens.fontSize7xl,
  '8xl': tokens.fontSize8xl,
};

export const semanticLetterSpacing = {
  xs: clarityTokens.letterSpacingXs,
  sm: clarityTokens.letterSpacingSm,
  reg: clarityTokens.letterSpacingReg,
  lg: clarityTokens.letterSpacingLg,
  xl: clarityTokens.letterSpacingXl,
};

export const semanticLineHeight = {
  single: clarityTokens.lineHeightSingle,
  short: clarityTokens.lineHeightShort,
  long: clarityTokens.lineHeightLong,
  double: clarityTokens.lineHeightDouble,
  standard: clarityTokens.lineHeightStandard,
};

export const semanticSpacing = {
  none: clarityTokens.spacingNone,
  '4xs': clarityTokens.spacing4xs,
  '3xs': clarityTokens.spacing3xs,
  '2xs': clarityTokens.spacing2xs,
  xs: clarityTokens.spacingXs,
  sm: clarityTokens.spacingSm,
  base: clarityTokens.spacingBase,
  lg: clarityTokens.spacingLg,
  '2lg': clarityTokens.spacing2lg,
  xl: clarityTokens.spacingXl,
  '2xl': clarityTokens.spacing2xl,
  '3xl': clarityTokens.spacing3xl,
  '4xl': clarityTokens.spacing4xl,
  '5xl': clarityTokens.spacing5xl,
  '6xl': clarityTokens.spacing6xl,
  '7xl': clarityTokens.spacing7xl,
};

export const semanticSize = {
  '8xs': clarityTokens.size8xs,
  '7xs': clarityTokens.size7xs,
  '6xs': clarityTokens.size6xs,
  '5xs': clarityTokens.size5xs,
  '4xs': clarityTokens.size4xs,
  '3xs': clarityTokens.size3xs,
  '2xs': clarityTokens.size2xs,
  xs: clarityTokens.sizeXs,
  sm: clarityTokens.sizeSm,
  md: clarityTokens.sizeMd,
  lg: clarityTokens.sizeLg,
  xl: clarityTokens.sizeXl,
};

// The ruled board shifts a request-screen card's, dot's or step button's colours over 120ms on hover
// and press. MUI's transition durations do not include 120ms, so the value is written once here,
// in the theme layer, for the identity card and the request banner to share.
const stateTransitionDuration = '120ms';

// Request-screen identity card (verifime-adr#617). Width and avatar size reuse semantic sizes.
// No semantic size is 140 (8.75rem), so the fixed card height is the width plus one `sm` spacing
// step, expressed from tokens instead of a hard-coded rem value.
export const identityCard = {
  width: semanticSize['3xs'],
  height: `calc(${semanticSize['3xs']} + ${semanticSpacing.sm})`,
  avatarSize: semanticSize['5xs'],
  // The phone "verify a new" option row caps at 412px (25.75rem). No semantic size sits near it
  // (`xs` is 350px, `sm` is 600px), so this one value is written out here, in the theme layer.
  optionRowMaxWidth: '25.75rem',
  // The ruled board dims an identity already shared with the provider to 55% opacity. No semantic
  // token holds an opacity, so the value is written here, in the theme layer.
  unavailableOpacity: 0.55,
  stateTransitionDuration,
};

// Request-screen action buttons (verifime-adr#617). The ruled board draws its buttons 44px high,
// where the theme's default button is 48px (`size5xs`). No semantic size is 44 (2.75rem), so the
// value is written out here, in the theme layer.
export const requestActions = {
  buttonHeight: '2.75rem',
};

// Request banner on Home (verifime-adr#617). The ruled board draws the "n of m" counter in IBM Plex
// Mono. No theme font family is monospaced and the face is not self-hosted, so this one value is
// written out here, in the theme layer: the board's face first, then the system monospace faces.
export const requestBanner = {
  counterFontFamily: '"IBM Plex Mono", ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
  // The stepping control draws one dot per open request. The board's dot is 8px, the same step as
  // the semantic `xs` spacing, and its end dots shrink to 5px while more requests lie beyond them.
  // No semantic step is 5px, so that one value is written here, in the theme layer.
  dotSize: semanticSpacing.xs,
  edgeDotSize: '0.3125rem',
  stateTransitionDuration,
};

// Request card on the Requests tab (verifime-adr#617). The ruled board draws the menu button as a
// 36px circle. The nearest semantic sizes are 32px (`6xs`) and 48px (`5xs`), so this one value is
// written out here, in the theme layer.
export const requestCard = {
  menuButtonSize: '2.25rem',
};

// Dismissal dialog (verifime-adr#617). The ruled board draws it 520px wide. The nearest semantic
// sizes are 350px (`xs`) and 600px (`sm`), so this one value is written out here, in the theme layer.
export const requestDialog = {
  width: '32.5rem',
};

export const commonComponentsOverride: Components<Omit<Theme, 'components'>> = {
  MuiTypography: {
    defaultProps: {
      color: 'textPrimary',
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: clarityTokens.spacing2xs,
        paddingTop: clarityTokens.spacingSm,
        paddingRight: clarityTokens.spacingBase,
        paddingBottom: clarityTokens.spacingSm,
        paddingLeft: clarityTokens.spacingBase,
        minHeight: clarityTokens.size5xs,
      },
    },
    variants: [
      {
        props: { size: 'small' },
        style: {
          fontSize: clarityTokens.fontSizeXs,
          fontWeight: clarityTokens.fontWeightSemibold,
          letterSpacing: clarityTokens.letterSpacingReg,
          lineHeight: clarityTokens.lineHeightSingle,
        },
      },
      {
        props: { size: 'medium' },
        style: {
          fontSize: clarityTokens.fontSizeSm,
          fontWeight: clarityTokens.fontWeightSemibold,
          letterSpacing: clarityTokens.letterSpacingReg,
          lineHeight: clarityTokens.lineHeightSingle,
        },
      },
      {
        props: { size: 'large' },
        style: {
          fontSize: clarityTokens.fontSizeBase,
          fontWeight: clarityTokens.fontWeightSemibold,
          letterSpacing: clarityTokens.letterSpacingReg,
          lineHeight: clarityTokens.lineHeightSingle,
        },
      },
    ],
  },
  MuiLink: {
    defaultProps: {
      underline: 'always',
      fontSize: clarityTokens.fontSizeBase,
      fontWeight: clarityTokens.fontWeightRegular,
      letterSpacing: clarityTokens.letterSpacingReg,
      lineHeight: clarityTokens.lineHeightStandard,
    },
  },
};
